import { render, staticRenderFns } from "./Visual.vue?vue&type=template&id=63724d95&"
import script from "./Visual.vue?vue&type=script&lang=js&"
export * from "./Visual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports